import { cn } from '@/lib/cn';
import type { ProcedureStatus } from '@/services/procedure-template.service';

interface Props {
  status: ProcedureStatus;
  className?: string;
}

const CONFIG: Record<ProcedureStatus, { label: string; cls: string }> = {
  DRAFT: { label: 'Draft', cls: 'bg-amber-500/10 text-amber-700 border border-amber-300/40' },
  PUBLISHED: { label: 'Published', cls: 'bg-primary/10 text-primary border border-primary/30' },
  ARCHIVED: { label: 'Archived', cls: 'bg-muted text-muted-foreground border border-border' },
};

export function ProcedureStatusBadge({ status, className }: Props) {
  const { label, cls } = CONFIG[status];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        cls,
        className,
      )}
    >
      {label}
    </span>
  );
}
